/**
 * Extracts the server-provided error message from an axios error response.
 * API 4xx responses carry `{ error: string }` — fall back when absent so the
 * caller always has something displayable.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  return (err as { response?: { data?: { error?: string } } })?.response?.data?.error ?? fallback;
}
